export default __webpack_public_path__ + "assets/images/topaasia-hex-logo-white.d383463bf1014145bccde3d3fa032b40.png";